import { mapActions } from 'vuex';

import { validateEmail } from '@helpers';

export default {
  name: 'OperatorSynchronizer',
  data() {
    return {
      email: '',
      dialog: false,
    };
  },
  computed: {
    emailErrorConfig() {
      const isValidEmail = validateEmail(this.email);
      return {
        error: !isValidEmail,
        errorMessages: isValidEmail ? [] : ['Invalid email'],
      };
    },
    isInvalidForm() {
      return this.emailErrorConfig.error;
    },
  },
  methods: {
    ...mapActions('operators', ['syncOperator']),
    async synchronize() {
      if (this.isInvalidForm) {
        return;
      }

      this.$VBlackerTheme.openLoadingSpinner();

      try {
        await this.syncOperator({ email: this.email });
        this.$emit('success');
        this.dialog = false;
      } catch (e) {
        this.$VBlackerTheme.notification.error(e);
      } finally {
        this.$VBlackerTheme.closeLoadingSpinner();
      }
    },
    resetFormData() {
      this.email = '';
    },
  },
};
